// extracted by mini-css-extract-plugin
export default {"card":"Unauthorized_card__M1FWu","title":"Unauthorized_title__KUwRe","text":"Unauthorized_text__c4knx","link":"Unauthorized_link__OCxaa"};